import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const EXPORT_RECORDS: AppRouteRecordRaw = {
  path: '/export-records',
  name: 'ExportRecordsRoot',
  component: DEFAULT_LAYOUT,
  redirect: '/export-records/list',
  meta: {
    locale: 'menu.exportRecords',
    requiresAuth: true,
    icon: 'icon-download',
    order: 5,
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'ExportRecords',
      component: () => import('@/views/order/export-records/index.vue'),
      meta: {
        locale: 'menu.exportRecords',
        requiresAuth: true,
        roles: ['*'],
        activeMenu: 'ExportRecordsRoot',
      },
    },
  ],
};

export default EXPORT_RECORDS;
